import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Page } from '@containers/layout';
import { Heading, Box, Button, LinkText } from '@components/common';
import useDetectSize from '@hooks/useDetectSize';
import {
  AccountInfo,
  PaymentInfo,
  ApartmentInfo,
  OtherInfo
} from '@containers/account';
import { MobileContainer } from '@containers/layout';
import AuthActions, { AuthSelectors } from '@redux/AuthRedux';
import { trackLogOut } from '@services/analytics';

const Wrapper = styled(Box)`
  width: 345px;
`;

function AccountPage(props) {
  const isMobile = useDetectSize();
  const { signOut, isPMUser } = props;

  const handleSignout = () => {
    trackLogOut();
    signOut();
  };

  const renderMobileLayout = () => {
    return (
      <MobileContainer pt={4}>
        <AccountInfo />
        <OtherInfo />
        {!isPMUser && <ApartmentInfo />}
        <PaymentInfo />
        <Button mb={4} onClick={handleSignout}>
          Sign Out
        </Button>
      </MobileContainer>
    );
  };

  const renderDesktopLayout = () => {
    if (isPMUser) {
      return (
        <Box flex={1} alignSelf="stretch" py={5} px={7}>
          <Box
            display={['none', 'flex']}
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Heading mr={5}>My Account</Heading>
            <LinkText mb={4} pb={2} onClick={handleSignout}>
              Sign Out
            </LinkText>
          </Box>
          <Box display="flex" flexDirection="row" mb={4}>
            <Wrapper mr={5}>
              <AccountInfo />
            </Wrapper>

            <Wrapper mr={5}>
              <PaymentInfo />
            </Wrapper>
          </Box>
        </Box>
      );
    }

    return (
      <Box flex={1} alignSelf="stretch" py={5} px={7}>
        <Box
          display={['none', 'flex']}
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="flex-end"
        >
          <Heading mr={5}>My Account</Heading>
          <LinkText mb={4} pb={2} onClick={handleSignout}>
            Sign Out
          </LinkText>
        </Box>
        <Box display="flex" flexDirection="row" mb={4}>
          <Wrapper mr={5}>
            <AccountInfo />
          </Wrapper>
          <Wrapper ml={5}>
            <ApartmentInfo />
          </Wrapper>
        </Box>
        <Box display="flex" flexDirection="row">
          <Wrapper mr={5}>
            <OtherInfo />
          </Wrapper>
          <Wrapper ml={5}>
            <PaymentInfo />
          </Wrapper>
        </Box>
      </Box>
    );
  };
  return (
    <Page title="Account">
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </Page>
  );
}

AccountPage.propTypes = {
  signOut: PropTypes.func,
  isPMUser: PropTypes.bool
};

const mapStatesToProps = state => ({
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

const mapDispatchToProps = dispatch => ({
  signOut: () => dispatch(AuthActions.setLoggedOut())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(AccountPage);
